import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme/theme";
import { motion } from "framer-motion";

const StyledSocials = styled.div`
  a {
    margin-right: ${theme.marginBase * 5}px;
  }
  .item {
    overflow: visible;
    stroke: ${theme.colors.secondary};
    stroke-width: 0.5;
    stroke-linejoin: round;
    stroke-linecap: round;
    transition: stroke-width 0.1s ease-in-out;
    &:hover {
      stroke-width: 1;
    }
  }
`;

const icon = {
  hidden: {
    pathLength: 0,
    fill: "rgba(41, 243, 195, 0)",
  },
  visible: {
    pathLength: 1,
    fill: "rgba(41, 243, 195, 0.8)",
  },
};

const Socials = () => {
  return (
    <StyledSocials>
      <a href="https://github.com/Shishouille" target="_blank" rel="noreferrer">
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          width="41.831"
          height="40.819"
          viewBox="0 0 41.831 40.819"
          className="item"
        >
          <motion.path
            id="github"
            d="M20.913,0a20.459,20.459,0,0,1,10.5,2.8,20.817,20.817,0,0,1,7.613,7.611,20.459,20.459,0,0,1,2.8,10.5,20.325,20.325,0,0,1-3.994,12.295,20.489,20.489,0,0,1-10.308,7.557,1.221,1.221,0,0,1-1.09-.19,1.064,1.064,0,0,1-.355-.817q0-.082.014-2.083t.014-3.662a4.851,4.851,0,0,0-1.416-3.867,18.7,18.7,0,0,0,2.791-.49,11.117,11.117,0,0,0,2.56-1.062,7.6,7.6,0,0,0,2.2-1.812,8.448,8.448,0,0,0,1.443-2.859,13.735,13.735,0,0,0,.563-4.1A8.065,8.065,0,0,0,32.1,14.216a7.251,7.251,0,0,0-.219-5.555,3.564,3.564,0,0,0-2.2.3,14.71,14.71,0,0,0-2.505,1.2l-1.034.653a19.67,19.67,0,0,0-10.457,0q-.436-.3-1.157-.736a16.379,16.379,0,0,0-2.272-1.049,3.745,3.745,0,0,0-2.314-.368,7.251,7.251,0,0,0-.219,5.555A8.065,8.065,0,0,0,7.568,19.82a13.611,13.611,0,0,0,.558,4.085,8.722,8.722,0,0,0,1.431,2.859,7.38,7.38,0,0,0,2.193,1.824,11.06,11.06,0,0,0,2.56,1.062,18.768,18.768,0,0,0,2.791.49,4.6,4.6,0,0,0-1.334,2.8,5.441,5.441,0,0,1-1.226.409,7.612,7.612,0,0,1-1.552.136,3.22,3.22,0,0,1-1.783-.584,4.787,4.787,0,0,1-1.512-1.7,4.39,4.39,0,0,0-1.321-1.416,3.987,3.987,0,0,0-1.348-.654l-.545-.082a1.777,1.777,0,0,0-.79.122q-.219.122-.136.314a1.5,1.5,0,0,0,.245.381,2,2,0,0,0,.355.326l.19.136A3.28,3.28,0,0,1,7.529,31.37a6.827,6.827,0,0,1,.858,1.388l.272.626a3.45,3.45,0,0,0,1.2,1.674,4.248,4.248,0,0,0,1.824.817,11.516,11.516,0,0,0,1.893.19,8.113,8.113,0,0,0,1.512-.1l.626-.109q0,1.035.014,2.409t.014,1.484a1.064,1.064,0,0,1-.355.817,1.221,1.221,0,0,1-1.09.19A20.483,20.483,0,0,1,3.985,33.205,20.324,20.324,0,0,1,0,20.913a20.459,20.459,0,0,1,2.8-10.5A20.817,20.817,0,0,1,10.415,2.8,20.459,20.459,0,0,1,20.913,0ZM7.923,30.036q.082-.19-.19-.326-.272-.082-.355.057-.082.19.19.326Q7.815,30.254,7.923,30.036Zm.844.926q.19-.136-.057-.436-.272-.245-.436-.082-.19.136.057.436.272.271.436.082Zm.817,1.226q.245-.19,0-.517-.219-.355-.462-.164-.245.136,0,.49t.462.19Zm1.144,1.143q.219-.219-.109-.517-.326-.326-.545-.082-.245.219.109.517.326.327.545.082Zm1.552.68q.082-.3-.355-.436-.409-.109-.517.19t.355.409Q12.172,34.338,12.28,34.01ZM14,34.146q0-.355-.462-.3-.436,0-.436.3,0,.355.462.3.435,0,.435-.3Zm1.579-.272q-.057-.3-.49-.245-.436.082-.381.409t.49.219q.436-.109.381-.381Z"
            transform="translate(0.002 0.001)"
            variants={icon}
            initial="hidden"
            animate="visible"
            transition={{
              default: { duration: 2, ease: "easeInOut" },
              fill: { duration: 2, ease: [1, 0, 0.8, 1] },
            }}
          />
        </motion.svg>
      </a>
      <a
        href="https://www.linkedin.com/in/shirin-boomi/"
        target="_blank"
        rel="noreferrer"
      >
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          width="42.703"
          height="40.819"
          viewBox="0 0 42.703 40.819"
          className="item"
        >
          <motion.path
            id="linkedin"
            d="M9.693,40.819V13.279H.54v27.54ZM5.118,9.515C8.309,9.515,10.3,7.4,10.3,4.758A4.757,4.757,0,0,0,5.178,0C2.047,0,0,2.057,0,4.758A4.739,4.739,0,0,0,5.058,9.515h.059Zm9.642,31.3h9.154V25.439a6.266,6.266,0,0,1,.3-2.233,5.011,5.011,0,0,1,4.7-3.348c3.313,0,4.637,2.525,4.637,6.228V40.819H42.7V25.027c0-8.46-4.516-12.4-10.539-12.4a9.116,9.116,0,0,0-8.31,4.64h.062V13.277H14.761c.12,2.584,0,27.54,0,27.54Z"
            variants={icon}
            initial="hidden"
            animate="visible"
            transition={{
              default: { duration: 2, ease: "easeInOut" },
              fill: { duration: 2, ease: [1, 0, 0.8, 1] },
            }}
          />
        </motion.svg>
      </a>
      <a
        href="mailto:shirin.boomi.dev@gmail.com"
        target="_blank"
        rel="noreferrer"
      >
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          width="40.819"
          height="40.819"
          viewBox="0 0 40.819 40.819"
          className="item"
        >
          <motion.path
            id="webmail"
            d="M26.588,20.41l11-11a20.356,20.356,0,0,1,0,22ZM4.744,7.335A20.483,20.483,0,0,1,11.7,1.954a20.392,20.392,0,0,1,17.42,0,20.457,20.457,0,0,1,6.955,5.381L20.41,23ZM3.229,31.411a20.356,20.356,0,0,1,0-22l11,11Zm12.8-9.208,2.83,2.87a1.794,1.794,0,0,0,.618.319,2.242,2.242,0,0,0,.658.119h.279a2.1,2.1,0,0,0,1.555-.439l2.83-2.87L36.075,33.483a20.484,20.484,0,0,1-6.956,5.381,20.387,20.387,0,0,1-17.42,0,20.476,20.476,0,0,1-6.955-5.381Z"
            variants={icon}
            initial="hidden"
            animate="visible"
            transition={{
              default: { duration: 2, ease: "easeInOut" },
              fill: { duration: 2, ease: [1, 0, 0.8, 1] },
            }}
          />
        </motion.svg>
      </a>
    </StyledSocials>
  );
};

export default Socials;
